<template>
  <StaticDataTable class="static-table-list" v-if="task && taskScannedItemList" :striped="false" :hover="true">
    <template v-slot:header>
      <tr>
        <th width="25px"></th>
        <th width="25px"></th>
        <th width="25%">Info</th>
        <th width="6%">Order</th>
        <th width="25%">Item</th>
        <th width="7%">Scan In Qty</th>
        <th width="7%">Scan Out Qty</th>
        <th width="10%">Scan In Time</th>
        <th width="10%">Scan Out Time</th>
        <th width="10%">Inventory Bin</th>
      </tr>
    </template>
    <template v-slot:body>
      <template v-for="taskItem in taskItemList">
        <tr :key="taskItem.id" :data-sort-id="taskItem.id">
          <td class="tasks-item-row-index-marker">{{taskItem.displayIndex}}</td>
          <td>
            <ExpandCollapseButton v-model="taskItem.expanded" />
          </td>
          <td>
            <strong>{{taskItem.name}}</strong>
          </td>
          <td>-</td>
          <td>-</td>
          <td class="font-weight-bold">{{taskItem.totalScannedInQuantity}}</td>
          <td class="font-weight-bold">{{taskItem.totalScannedOutQuantity}}</td>
          <td>-</td>
          <td>-</td>
          <td>-</td>
        </tr>

        <template v-if="taskItem.expanded">
          <tr v-for="scannedItem of taskItem.taskScannedItemList" :key="`scannedItem-${scannedItem.id}`">
            <td></td>
            <td></td>
            <td v-if="scannedItem.scannedType == ScannedItemTypes.general">General Stock</td>
            <td v-if="scannedItem.scannedType == ScannedItemTypes.glassLevel">{{scannedItem.glassLevel.height}} x {{scannedItem.glassLevel.width}} Stock Sheet</td>
            <td v-if="scannedItem.scannedType == ScannedItemTypes.glassBlock">Block - {{scannedItem.glassBlock.barcode}}</td>
            <td v-if="scannedItem.scannedType == ScannedItemTypes.productionPanel">
              Panel - <LinkProductionPanel :id="scannedItem.productionPanelId" :name="scannedItem.productionPanel.barcode" />
            </td>
            <td>
              <LinkOrder :id="scannedItem.orderItem.order.id" :name="scannedItem.orderItem.order.sequenceNumber" v-if="scannedItem.orderItem && scannedItem.orderItem.order" />
            </td>
            <td>
              <span v-if="scannedItem.orderItem">
                {{scannedItem.orderItem.description}} {{scannedItem.orderItem.generatedDescription}}<span v-if="isOrderItemGlass(scannedItem.orderItem)"> - {{scannedItem.orderItem.glassHeight}}x{{scannedItem.orderItem.glassWidth}}</span>
              </span>
              <span v-if="!taskItem.orderItem && scannedItem.taskItemLinkedItem && scannedItem.taskItemLinkedItem.stock">
                {{scannedItem.taskItemLinkedItem.stock.code}} - {{scannedItem.taskItemLinkedItem.stock.name}}
              </span>
            </td>
            <td>{{scannedItem.scannedInQuantity}}</td>
            <td>{{scannedItem.scannedOutQuantity}}</td>
            <td>{{formatHyphenEmptyValue(formatDateTime(scannedItem.scannedInDate))}}</td>
            <td>{{formatHyphenEmptyValue(formatDateTime(scannedItem.scannedOutDate))}}</td>
            <td>{{formatHyphenEmptyValue(scannedItem.srcInventoryBin ? scannedItem.srcInventoryBin.code : null)}}</td>
          </tr>
        </template>
        <template v-if="taskItem.expanded">
          <tr v-for="productionPanel of taskItem.unscannedProductionPanels" :key="`panel-${productionPanel.id}`">
            <td></td>
            <td></td>
            <td>Panel - <LinkProductionPanel :id="productionPanel.id" :name="productionPanel.barcode" /></td>
            <td>
              <LinkOrder :id="productionPanel.order.id" :name="productionPanel.order.sequenceNumber" v-if="productionPanel.order" />
            </td>
            <td>
              <span v-if="productionPanel.orderItem">
                {{productionPanel.orderItem.description}} {{productionPanel.orderItem.generatedDescription}}<span v-if="isOrderItemGlass(productionPanel.orderItem)"> - {{productionPanel.orderItem.glassHeight}}x{{productionPanel.orderItem.glassWidth}}</span>
              </span>
            </td>
            <td>0</td>
            <td>0</td>
            <td>{{formatHyphenEmptyValue(null)}}</td>
            <td>{{formatHyphenEmptyValue(null)}}</td>
            <td>{{formatHyphenEmptyValue(null)}}</td>
          </tr>
        </template>
      </template>
    </template>                    
    <template v-slot:empty v-if="taskItemList.length == 0">
      No task items available
    </template>
  </StaticDataTable>
</template>

<script>
import _ from 'lodash'

import { ScannedItemTypes, ScannedItemTypeLookup, TaskLinkedItemTypes, InventoryStockTypes, ProductionPanelStatusTypes } from '@/store/types'

export default {
  name: 'TaskItemScannedList',
  props: {
    task: Object,
    taskScannedItemList: Array
  },
  created() {
    this.ScannedItemTypes = ScannedItemTypes
    this.ScannedItemTypeLookup = ScannedItemTypeLookup
  },
  computed: {
    isTaskLocationTracking() {
      if(!this.task.taskType)
        return false
      return this.task.taskType.isLocationTrackingEnabled
    },
  },
  data() {
    return {
      taskItemList: []
    }
  },
  watch: {
    taskScannedItemList: function() {
      this.buildTaskItemList()
    },
    task: function() {
      this.buildTaskItemList()
    }
  },
  mounted() {
    this.buildTaskItemList()
  },
  methods: {
    buildTaskItemList() {
      if(!this.task || !this.task.taskItems)
        return

      this.taskItemList = _.compact(this.task.taskItems.map((taskItem, taskItemIndex) => {
        let outputItem = _.cloneDeep(taskItem)

        outputItem.expanded = false
        outputItem.taskScannedItemList = (this.taskScannedItemList || []).filter(scannedItem => scannedItem.taskItemId == taskItem.id).map(scannedItem => _.cloneDeep(scannedItem))
        outputItem.displayIndex = taskItemIndex+1
        outputItem.despatchOrderIdList = []
        outputItem.unscannedProductionPanels = []    // Updated in requestFullPanelList()

        if(taskItem.taskItemLinkedItems) {
         taskItem.taskItemLinkedItems.forEach(linkedItem => {
            // Only for OrderItem despatch type
            if(linkedItem.type == TaskLinkedItemTypes.orderItem) {
              outputItem.despatchOrderIdList.push(linkedItem.orderId)
            }
          })
        }

        // Fill in extra info for scanned item list
        outputItem.taskScannedItemList.forEach(scannedItem => {
          scannedItem.taskItemLinkedItem = null
          if(taskItem.taskItemLinkedItems) {
            scannedItem.taskItemLinkedItem = taskItem.taskItemLinkedItems.find(linkedItem => linkedItem.id == scannedItem.taskItemLinkedItemId)
          }
        })

        // Ignore items with no linked orders or orderItems & no scanned items
        if(taskItem.taskItemLinkedItems && taskItem.taskItemLinkedItems.length == 0 && outputItem.taskScannedItemList.length == 0)
          return null

        outputItem.totalScannedInQuantity = outputItem.taskScannedItemList.reduce((curValue, scannedItem) => {
          return curValue + scannedItem.scannedInQuantity
        }, 0)
        outputItem.totalScannedOutQuantity = outputItem.taskScannedItemList.reduce((curValue, scannedItem) => {
          return curValue + scannedItem.scannedOutQuantity
        }, 0)

        return outputItem
      }))

      // Get all panels referenced by the linked orderItems so we can display panels that have not been scanned in (and should of been)
      // Used for displaying partial load-in of panels
      this.requestFullPanelList()
    },
    isOrderItemGlass(orderItem) {
      return orderItem.stockType == InventoryStockTypes.glass
    },
    requestFullPanelList() {
      var orderIdList = []

      this.taskItemList.forEach(taskItem => {
        orderIdList = _.concat(orderIdList, taskItem.despatchOrderIdList)
      })

      orderIdList = _.uniq(orderIdList)
      if(orderIdList.length > 0) {        
        var panelFilter = {
          orderId: { in: orderIdList.join(',') },
          status: { in: [ProductionPanelStatusTypes.pending, ProductionPanelStatusTypes.production, ProductionPanelStatusTypes.despatch, ProductionPanelStatusTypes.completed] }
        }

        this.$apiService.productionService.getProductionPanelList({ filter: panelFilter })
        .then(response => {
          let panelList = response.data

          // Fill in panels
          this.taskItemList.forEach(taskItem => {
            taskItem.unscannedProductionPanels = panelList.filter(panel => taskItem.despatchOrderIdList.includes(panel.orderId))

            // Filter out panels that have been scanned
            taskItem.unscannedProductionPanels = taskItem.unscannedProductionPanels.filter(panel => {

              return !taskItem.taskScannedItemList.some(scannedItem => scannedItem.productionPanelId == panel.id)
            })

            // Filter out internal panels that are part of an assembly
            taskItem.unscannedProductionPanels = taskItem.unscannedProductionPanels.filter(panel => !panel.isInternalItem)
          })
        })
        .catch(err => {
          console.log(err)
        })
      }
    }
  }
}
</script>